import React, { useEffect, useState } from 'react'
import InfoPageService from 'services/InfoPageService'
import {
  BlogContent,
  BlogTitle,
  BlogWrapper,
  Description,
} from 'style/Blog.style'

const InfoPage = props => {
  const slug = props.match.params.slug
  const [page, setPage] = useState({})

  useEffect(() => {
    InfoPageService.getBySlug(slug).then(data => {
      if (data.page) {
        data.page.suggestions = data.suggestions
        setPage(data.page)
        document.title = data.page.title
        window.scrollTo(0, 0)
      }
    })
  }, [slug])

  return (
    <BlogWrapper className="blog-page" withoutSidebar>
      <BlogContent>
        <BlogTitle>
          <h2>{page.title}</h2>
        </BlogTitle>
        <Description dangerouslySetInnerHTML={{ __html: page.text }} />
      </BlogContent>
    </BlogWrapper>
  )
}

export default InfoPage
